module.exports = __webpack_public_path__ + "static/media/project_empty_wave@2x.bdc2cc4a.png";